import { apiClient } from "../../../lib/axios";
import type {
  OnboardingQuestionsResponse,
  OnboardingResponsesRequest,
  OnboardingResponsesResponse,
} from "./types";

export const onboardingApi = {
  getQuestions: async (): Promise<OnboardingQuestionsResponse> => {
    const response = await apiClient.get("/onboarding/questions");
    return response.data;
  },

  submitResponses: async (
    data: OnboardingResponsesRequest
  ): Promise<OnboardingResponsesResponse> => {
    const response = await apiClient.post("/onboarding/responses", data);
    return response.data;
  },
};
